// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  bar: "OutputPanels__bar",
  barFill: "OutputPanels__barFill",
  barName: "OutputPanels__barName",
  barValue: "OutputPanels__barValue",
  bars: "OutputPanels__bars",
  column: "OutputPanels__column",
  flowNote: "OutputPanels__flowNote",
  gdpName: "OutputPanels__gdpName",
  gdpRow: "OutputPanels__gdpRow",
  gdpRows: "OutputPanels__gdpRows",
  grid: "OutputPanels__grid",
  mini: "OutputPanels__mini",
  panel: "OutputPanels__panel",
  panelFoot: "OutputPanels__panelFoot",
  panelHead: "OutputPanels__panelHead",
  panelNote: "OutputPanels__panelNote",
  panelWide: "OutputPanels__panelWide",
  priceBase: "OutputPanels__priceBase",
  single: "OutputPanels__single",
  splitCapital: "OutputPanels__splitCapital",
  splitLabour: "OutputPanels__splitLabour",
  splitRead: "OutputPanels__splitRead",
  waffle: "OutputPanels__waffle",
  waffleHead: "OutputPanels__waffleHead",
  waffleName: "OutputPanels__waffleName",
  waffleRow: "OutputPanels__waffleRow",
};
